<template><div></div></template>
<script>
import { auth } from '@/js/db'
import { isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth'

export default {
  name: 'auth',
  async mounted() {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      let email = window.localStorage.getItem('emailForSignIn')

      if (!email) {
        email = window.prompt('Please provide your email for confirmation')
      }

      await signInWithEmailLink(auth, email, window.location.href)
      window.localStorage.removeItem('emailForSignIn')
      window.location.href = '/'
    } else {
      console.log('Not a valid login link')
    }
  }
}
</script>
